<div class="custom-card p-2">
  <div class="mb-2">
    <span class="secondary-details mb-2">{{ 'configuration.shipperTaxSetting.shipperTaxSetting' | translate }}</span>
  </div>

  <div [formGroup]="shipperTaxSetting">
    <div formArrayName="data">
      <ng-container>
        <table aria-describedby="Shipper-table" mat-table [dataSource]="ShipperDataSource">
          <ng-container matColumnDef="number">
            <th id="number" mat-header-cell *matHeaderCellDef>{{ 'configuration.shipperTaxSetting.number' | translate }}</th>
            <td mat-cell *matCellDef="let row; let i = index">
              {{ i + 1 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="shipperRegistrationType">
            <th
              class="required-field"
              id="shipperRegistrationType"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'configuration.shipperTaxSetting.shipperRegistrationType' | translate }}
            </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <select
                [ngStyle]="{
                  'border-color': getShipperFormControlId(i, 'shipperRegistrationType').errors
                    ? 'red'
                    : 'grey'
                }"
                class="form-control"
                formControlName="shipperRegistrationType">
                <option value="">{{ 'configuration.shipperTaxSetting.selectRegistrationType' | translate }}</option>
                <option
                  *ngFor="let eachType of shipperRegistraionTypes | dataPropertyGetter"
                  [value]="eachType.key">
                  {{ eachType.key }}, {{ eachType.value }}
                </option>
              </select>
            </td>
          </ng-container>

          <ng-container matColumnDef="shipperRegistrationNumber">
            <th
              class="required-field"
              id="shipperRegistrationNumber"
              mat-header-cell
              *matHeaderCellDef>
              {{ 'configuration.shipperTaxSetting.shipperRegistrationNumber' | translate }}
            </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input
                [ngStyle]="{
                  'border-color': getShipperFormControlId(i, 'shipperRegistrationNumber').errors
                    ? 'red'
                    : 'grey'
                }"
                class="form-control"
                type="text"
                formControlName="shipperRegistrationNumber" />
            </td>
          </ng-container>

          <ng-container matColumnDef="shipperIssuingCountryCode">
            <th class="required-field" id="packageLength" mat-header-cell *matHeaderCellDef>
              {{ 'configuration.shipperTaxSetting.shipperIssuingCountryCode' | translate }}
            </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <select
                [ngStyle]="{
                  'border-color': getShipperFormControlId(i, 'shipperIssuingCountryCode').errors
                    ? 'red'
                    : 'grey'
                }"
                class="form-control"
                formControlName="shipperIssuingCountryCode">
                <option value="">{{ 'configuration.shipperTaxSetting.selectCountry' | translate }}</option>
                <option *ngFor="let eachListVal of list" [value]="eachListVal.code">
                  {{ eachListVal.name }}
                </option>
              </select>
            </td>
          </ng-container>

          <ng-container matColumnDef="Action">
            <th id="action" mat-header-cell *matHeaderCellDef>{{ 'global.action' | translate }}</th>
            <td mat-cell *matCellDef="let row; let i = index">
              <button
                (click)="DeleteShipperItem(pieces, i)"
                class="ml-2 secondary-btn"
                type="button">
                {{ 'global.delete' | translate }}
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>

          <tr class="mat-row justify-content-center" *matNoDataRow>
            {{ 'global.noDataAvailable' | translate }}
          </tr>
        </table>
      </ng-container>
    </div>
    <div class="col-12 text-end">
      <button (click)="AddNewShipperItem()" class="secondary-btn" type="button">{{ 'global.addRow' | translate }}</button>
      <button
        [disabled]="!(this.shipperTaxSetting.valid && isValueChanged)"
        (click)="saveShipperConfig()"
        class="primary-btn ml-1"
        type="button">
        {{ 'global.save' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="custom-card p-2">
  <app-receiver-taxsetting [configurationReceiver]="configReceiver"></app-receiver-taxsetting>
</div>

<div class="custom-card p-2">
  <app-importer-taxsetting [configurationImporter]="configImported"></app-importer-taxsetting>
</div>
